import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './call-out.scss';
import { isValid, decodeTags } from '../../../../utils';

const CallOut = ({ data }) => {
  if (!isValid(data)) { return null; }
  let encodedData = '';
  let header = null;

  if (typeof data === 'object') {
    encodedData = decodeTags(data.bodyText);
    header = isValid(data.header) ? data.header : null;
  } else if (typeof data === 'string') {
    encodedData = decodeTags(data);
  }
  if (encodedData.includes('<s>')) {
    encodedData = encodedData.replace(/<s>/g, '<s style="font-weight:200;">');
  }

  return (
    <Fragment>
      <div className='callout-wrapper'>
        <div className='body-wrapper'>
          <div className='callout-body' dangerouslySetInnerHTML={{ __html: encodedData }} />
        </div>
        {header && <p className='callout-header'>{header}</p>}
      </div>
    </Fragment>
  );
};

CallOut.propTypes = {
  className: PropTypes.string,
};

export default CallOut;
